import { useCallback } from 'react';

import { Analytics } from '@/states/analytics';

export const useAnalytics = () => {
  const listenForUtmSource = useCallback(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const utmSource = searchParams.get('utm_source');
    if (utmSource) {
      Analytics.setUtmSource(utmSource);
    }
  }, []);

  const getUtmSource = useCallback(() => {
    return Analytics.getUtmSource();
  }, []);

  return {
    listenForUtmSource,
    getUtmSource,
  };
};
